import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  ref,
  reactive,
  withDefaults,
} from "vue";
import { 
  decproApplyApi,//装修、采购协议提交
  decproDetailApi,//装修、采购协议详情
  decproTurnApi,//装修、采购协议回传
 } from "@/api/businessChange";
import Image from "@/components/Image.vue";
import { File, NodeItem } from "@/types/procss";
import change from "@/composables/change"
import type { FormInstance } from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    BranchCompanyFlowId: { default: 0 },
    preData: { default: () => [] },
    reEdit: { type: Boolean, default: false },
    update: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { BranchCompanyFlowId: number, preData:NodeItem[], reEdit:boolean, update: boolean }



const IsBGCGEdit = ref<boolean>(false); //办公采购是否能编辑
const IsFWZXEdit = ref<boolean>(false); //房屋装修是否能编辑

const turnDecproFormRef = ref<FormInstance>(); //装修及采购回传

let turnDecpro = reactive<Record<string, any>>({//回传展示
  PageFiles: [],
});
let turnDecproModel = reactive<Record<string, any>>({//弹窗回传
  PageFiles: [],
});

const IsFirstFWZLEdit = ref<boolean>(false); //是否第一次上传房屋租赁
const IsFirstCGEdit = ref<boolean>(false); //是否第一次上传采购
//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    if (isShowModel.value) {
      turnDecproModel.PageFiles[index as number] = {};
    } else {
      FormData.PageFiles[index as number] ={}
    }
  } else {
    if (isShowModel.value) {
      turnDecproModel.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    } else {
      if(!FormData.PageFiles[index] || !FormData.PageFiles[index].FileUrl){
        if(index == 0){//判断审批页面是否有删除标识
          IsFirstFWZLEdit.value = true; //是否第一次提交
        }else if(index == 1){
          IsFirstCGEdit.value = true; //是否第一次提交
        }
      }
      FormData.PageFiles[index] = {
        ...file,
        FileUrl: file.Url,
      };
    }
  }
};


// 表单字段定义
const FormData = reactive({
  PageFiles:[],
});

//封装方法字段
const FormRef = ref()
const common = reactive({
  ApplyApi:decproApplyApi,
  DetailApi:decproDetailApi,
  FormData:FormData,
  nodeIdx:4,
  FormRef:FormRef,
  turnDecpro:turnDecpro,
  turnApi:decproTurnApi,
  turnFormRef:turnDecproFormRef,
  IsBGCGEdit:IsBGCGEdit,
  IsFWZXEdit:IsFWZXEdit,
  turnDecproModel:turnDecproModel,
  IsFirstEdit1:IsFirstCGEdit,
  IsFirstEdit2:IsFirstFWZLEdit,
  props:reactive(props),
})

const {
  edit,
  isShowModel,
  submitTurnaroundDecproApply,
  winHeight,
  actionButtons,
} = change(common)


return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      style: _normalizeStyle({ minHeight: _unref(winHeight) + 'px' }),
      layout: "vertical",
      colon: false,
      ref_key: "FormRef",
      ref: FormRef,
      model: _unref(FormData),
      validateTrigger: "blur",
      class: _normalizeClass(["form-upload flex", !_unref(edit)? 'border-bottom mb24': ''])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          name: "turn",
          label: "房屋装修协议（若有）",
          class: "form-upload-item"
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              "disable-close": !(IsFirstFWZLEdit.value || (IsFWZXEdit.value && _unref(edit))),
              disable: !!__props.preData || !(_unref(edit) || _unref(actionButtons).includes('-3')),
              value: _unref(FormData).PageFiles[0] && _unref(FormData).PageFiles[0].FileUrl,
              "file-type": '921',
              onUpload: _cache[0] || (_cache[0] = (file) => handleUpload(file, 0))
            }, null, 8, ["disable-close", "disable", "value"])
          ]),
          _: 1
        }),
        (
        _unref(turnDecpro).PageFiles &&
        _unref(turnDecpro).PageFiles.length > 0 &&
        _unref(turnDecpro).PageFiles[0]?.FileUrl
      )
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              label: "房屋装修协议（回传）",
              class: "form-upload-item"
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  "disable-close": true,
                  disable: true,
                  value: _unref(turnDecpro).PageFiles[0] && _unref(turnDecpro).PageFiles[0].FileUrl,
                  "file-type": '9211',
                  onUpload: _cache[1] || (_cache[1] = (file) => handleUpload(file, 0))
                }, null, 8, ["value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, {
          name: ['PageFiles', 1, 'FileUrl'],
          label: "办公用品采购协议（若有）",
          class: "form-upload-item",
          style: {"width":"170px"},
          "label-col": { style: { whiteSpace: 'nowrap' } }
        }, {
          default: _withCtx(() => [
            _createVNode(Image, {
              "disable-close": !(IsFirstCGEdit.value || (IsBGCGEdit.value && _unref(edit))),
              disable: !!__props.preData || !(_unref(edit) || _unref(actionButtons).includes('-3')),
              "file-type": '922',
              value: _unref(FormData).PageFiles[1] && _unref(FormData).PageFiles[1].FileUrl,
              onUpload: _cache[2] || (_cache[2] = (file) => handleUpload(file, 1))
            }, null, 8, ["disable-close", "disable", "value"])
          ]),
          _: 1
        }),
        (
        _unref(turnDecpro).PageFiles &&
        _unref(turnDecpro).PageFiles.length > 1 &&
        _unref(turnDecpro).PageFiles[1]?.FileUrl
      )
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 1,
              label: "办公用品采购协议（回传）",
              class: "form-upload-item",
              style: {"width":"180px"}
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  "disable-close": true,
                  disable: true,
                  "file-type": '9221',
                  value: _unref(turnDecpro).PageFiles[1] && _unref(turnDecpro).PageFiles[1].FileUrl
                }, null, 8, ["value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["style", "model", "class"]),
    _createVNode(_component_a_modal, {
      layout: "vertical",
      class: "modal-dialog",
      visible: _unref(isShowModel),
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_isRef(isShowModel) ? (isShowModel).value = $event : null)),
      title: "装修、采购协议回传",
      onOk: _unref(submitTurnaroundDecproApply),
      onCancel: _cache[6] || (_cache[6] = ($event: any) => (_unref(isShowModel) == false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref_key: "turnDecproFormRef",
          ref: turnDecproFormRef,
          model: _unref(turnDecproModel),
          validateTrigger: "blur",
          class: "form-upload flex",
          colon: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: ['PageFiles', 0, 'FileUrl'],
              label: "房屋装修协议",
              class: "form-upload-item",
              rules: [{ required: true, message: '请回传房屋装修协议' }]
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: _unref(turnDecproModel).PageFiles[0] && _unref(turnDecproModel).PageFiles[0].FileUrl,
                  "disable-close": false,
                  "file-type": '9211',
                  onUpload: _cache[3] || (_cache[3] = (file) => handleUpload(file, 0))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: ['PageFiles', 1, 'FileUrl'],
              label: "办公用品采购协议",
              class: "form-upload-item",
              rules: [{ required: true, message: '请回传办公用品采购协议' }]
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: _unref(turnDecproModel).PageFiles[1] && _unref(turnDecproModel).PageFiles[1].FileUrl,
                  "file-type": '9221',
                  "disable-close": false,
                  onUpload: _cache[4] || (_cache[4] = (file) => handleUpload(file, 1))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ], 64))
}
}

})